import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "../AuthContext";
import { apiGet } from "./api-client";
const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { token } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      if (!token) { setSubscription(null); setLoading(false); return; }
      const res = await apiGet('/subscription');
      setSubscription(res.data);
    } catch {
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { setLoading(true); refresh(); }, [refresh]);

  return (
    <SubscriptionContext.Provider value={{ subscription, loading, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) return { subscription: null, loading: true, refresh: () => {} };
  return ctx;
}

export function canAccess(subscription, feature) {
  if (!subscription) return false;
  return subscription.limits?.[feature] === true || subscription.limits?.[feature] === -1;
}

export function getUsage(subscription, key) {
  if (!subscription) return { used: 0, limit: 0, remaining: 0, unlimited: false };
  const usage = subscription.usage || {};
  const limit = usage[`${key}_limit`];
  return {
    used: usage[key] || 0,
    limit: limit,
    remaining: usage[`${key}_remaining`],
    unlimited: limit === -1,
  };
}
